import { render, staticRenderFns } from "./NewVersionDialog.vue?vue&type=template&id=6895f0a1&scoped=true&"
import script from "./NewVersionDialog.vue?vue&type=script&lang=ts&"
export * from "./NewVersionDialog.vue?vue&type=script&lang=ts&"
import style0 from "./NewVersionDialog.vue?vue&type=style&index=0&id=6895f0a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6895f0a1",
  null
  
)

export default component.exports